/**
 * @fileoverview GET handler for the "/companies/:company_id/sender_verification/tracking_domains" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { companiesCompanyIdSenderVerificationTrackingDomains } from "./constants";
import type { CompaniesCompanyIdSenderVerificationTrackingDomainsResult } from "./types";

export const getCompaniesCompanyIdSenderVerificationTrackingDomains = reactQueryFetcherAdapter(
  companiesCompanyIdSenderVerificationTrackingDomains,
  (signal: AbortSignal, companyId: string): Promise<CompaniesCompanyIdSenderVerificationTrackingDomainsResult> => {
    return fetch(`/companies/${companyId}/sender_verification/tracking_domains`, "GET", {}, { signal });
  }
);
